import React from "react";
import { Text, View } from "@react-pdf/renderer";
import { withNamespaces } from "react-i18next";
import styles from "../../styles";
import { PageReference } from "../PageReference";

const SectionTitle = ({
    t,
    title,
    number,
    anchorId,
    breakBefore = false,
}) => {
    const content = (
        <View style={styles.sectionBlock} wrap={false} minPresenceAhead={180}>
            <PageReference id={anchorId} />
            <Text style={styles.sectionTitle}>
                {number ? `${number}. ${t(title)}` : t(title)}
            </Text>
        </View>
    );

    if (breakBefore) {
        return <View break>{content}</View>;
    }

    return content;
};

export default withNamespaces()(SectionTitle);
